import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class STBSEIRoboticsDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }

  setup () {
    STBSEIRoboticsDeviceSetup.getUserInfo();
  }

  static getUserInfo() {
  }
}

export default STBSEIRoboticsDeviceSetup;


// WEBPACK FOOTER //
// ./src/devices/seirobotics/DeviceSetup.js